<script>
export let carregando=false;


</script>

{#if carregando}
<div class="loading">
  <i class="fas fa-spinner fa-spin"></i> <!-- Ícone de carregamento -->
</div>
{/if}
<style>


.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px; /* Altura do ícone de carregamento */
  }

  .fa-spinner {
    animation: spin 1s infinite linear; /* Animação de rotação */
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

</style>

